import { createApp } from 'vue'

import App from './App.vue'
import router from './router'

import CustomAutocomplete from '@/components/ui/CustomAutocomplete.vue'
import CustomSelect from '@/components/ui/CustomSelect.vue'
import EmptyListState from '@/components/ui/EmptyListState.vue'
import LoadMoreButton from '@/components/ui/LoadMoreButton.vue'
import i18n from '@/plugins/i18n/config'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import pinia from '@/plugins/pinia'
import vuetify, { vPhoneInput } from '@/plugins/vuetify/config'
import initializeInterceptor from '@/services/utils/interceptor'
import initializeSentry from '@/plugins/sentry'
import { displayValueOrNoValue } from '@/utils/commonUtils'

import './assets/base.css'

const app = createApp(App)

app.config.globalProperties.$displayValue = displayValueOrNoValue
app.component('CustomAutocomplete', CustomAutocomplete)
app.component('CustomSelect', CustomSelect)
app.component('EmptyListState', EmptyListState)
app.component('LoadMoreButton', LoadMoreButton)

app.use(router)
app.use(vPhoneInput)
app.use(vuetify)
app.use(pinia)
app.use(i18n)
app.use(VueReCaptcha, { siteKey: window.APP_CONFIG.VITE_CAPTCHA })

initializeSentry(app, router)
initializeInterceptor()

app.mount('#app')
